var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.24,
    cx: 20,
    cy: 20,
    r: 19.65,
    stroke: "#1F2647",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0742 14.8436H17.1204V13.0957C17.1204 12.3216 17.5371 11.8802 18.3488 11.8802H21.6515V15.7822C21.6515 16.6065 22.0473 16.9876 22.8504 16.9876H26.4473V23.394C26.4473 24.1798 26.0306 24.6095 25.2253 24.6095H23.6963V25.6557H25.2766C26.7501 25.6557 27.5 24.8993 27.5 23.4129V17.289C27.5 16.4905 27.3308 15.9694 26.8247 15.4473L22.9357 11.5093C22.449 11.0097 21.9019 10.834 21.1915 10.834H18.291C16.8234 10.834 16.0742 11.5904 16.0742 13.0768V14.8436ZM22.6003 15.6423V12.4256L26.1587 16.0389H22.994C22.712 16.0389 22.6003 15.9243 22.6003 15.6423ZM12.5 27.0398C12.5 28.5327 13.2434 29.2826 14.7169 29.2826H21.7025C23.1759 29.2826 23.9258 28.5291 23.9258 27.0398V21.169C23.9258 20.2992 23.8187 19.9209 23.2801 19.3693L19.0729 15.1066C18.5603 14.581 18.1395 14.4609 17.3642 14.4609H14.7169C13.2492 14.4609 12.5 15.2173 12.5 16.7037V27.0398ZM13.5462 27.0209V16.7226C13.5462 15.9485 13.9629 15.5071 14.7747 15.5071H17.3309V19.8647C17.3309 20.7538 17.7802 21.1792 18.6454 21.1792H22.8731V27.0209C22.8731 27.8067 22.4564 28.2364 21.6512 28.2364H14.7682C13.9629 28.2364 13.5462 27.8067 13.5462 27.0209ZM18.7616 20.1979C18.4426 20.1979 18.3121 20.0674 18.3121 19.7484V15.7794L22.6656 20.1979H18.7616Z",
    fill: "#1F2647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.d34c504b9fff3888851623fd2abdbaf1.svg";
export { ForwardRef as ReactComponent };